module.exports = __webpack_public_path__ + "static/BrandonGrotesque-Regular-fb49d9de1f656416f646e278a7cee66f.woff2";